import React, { useEffect, useRef, useCallback } from 'react';
import { PromoVisualOptions, PromoColorsOptions } from '@box-types';

// todo implement shop.animations.ts
function PromoTagComponent(options: PromoVisualOptions) {
  const { text, image, colors } = options;
  const containerRef = useRef<HTMLDivElement>(null);

  const initializeColors = useCallback<(colors: PromoColorsOptions) => void>(
    (colors) => {
      const style = containerRef?.current?.style;
      if (!style || !colors) return;
      const { background, triangle, foreground, sideTag } = colors;

      style.setProperty('--background-color', background || '');
      style.setProperty('--triangle-color', triangle || '');
      style.setProperty('--font-color', foreground || '');
      style.setProperty('--side-tag-color', sideTag || background || '');
    },
    [colors]
  );

  useEffect(() => {
    initializeColors(colors);
  }, [colors]);

  return (
    <div className="box-promo-tag-component" ref={containerRef}>
      <div className="box-promo-tag-bg"></div>
      <div className="box-promo-tag-content">
        {image ? (
          <figure>
            <img src={image} alt={text} />
          </figure>
        ) : (
          <span className="ods-typography-microcopy-bold">{text}</span>
        )}
      </div>
    </div>
  );
}

export default PromoTagComponent;
